import React from "react";
import { Link } from "react-router-dom"; 

const Footer = () => {
  return (
    <footer className="border-t border-borderColor mt-16 py-6 px-4">
      <div className="flex flex-row flex-wrap justify-center space-x-4 text-gray-700">
        {/* Replace with <Link> if using react-router */}
         <Link to="/termandcondition" className="text-sm  !text-[#475467] hover:!text-primary">
          Terms and Conditions
        </Link>
        <span>|</span>
        <Link to="/policyandprivacy" className="text-sm !text-[#475467] hover:!text-primary">
          Privacy Policy
        </Link>
          <span>|</span>
        <Link to="/" className="text-sm !text-[#475467] hover:!text-primary">
          Contact Us
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
